import http from "infra/http";
import { useQuery } from "react-query";

import { RetornoBancarioFiltro, RetornoBancarioResumo } from "../typings";

export function useRetornoBancarioResumo(filtro: RetornoBancarioFiltro) {
  const queryResult = useQuery(
    [
      `/v1/retorno-bancario/resumo?dataInicio-${filtro.dataInicio}-dataFim-${filtro.dataFim}`,
    ],
    async () => {
      const { data } = await http.get<RetornoBancarioResumo>(
        `/v1/retorno-bancario/resumo`,
        {
          params: filtro,
        }
      );

      return data;
    }
  );

  return {
    ...queryResult,
  };
}
